var map = {
	"./carousel-0.png": "gF2X",
	"./carousel-1.png": "7JmJ",
	"./carousel-2.png": "i5EW"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZfL0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/carousel\-.*\.png$
// module id = ZfL0
// module chunks = 0